
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Card, CardContent, Divider, Button, CardActions } from "@mui/material";
import Swal from 'sweetalert2';
import { AddOrder } from '../utils/order';
import { CLEAR_CART } from '../features/productInCartSlice';
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import UserDetailsSection from "./UserDetailsSection";


const CheckoutSummary = () => {
    const loggedUser = useSelector((state) => state.user.logedUser);
    const cart = useSelector((state) => state.cart.items);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const total = cart.reduce((sum, item) => {
        const basePrice = Number(item.product?.price) || 0;
        const optionPrice = Number(item.productOption?.extraPrice) || 0; // מחיר וריאציה (אצלך זה "מחיר סופי")
        const unitPrice = optionPrice > 0 ? optionPrice : basePrice;

        return sum + unitPrice * (Number(item.amount) || 0);
    }, 0);


    if (!loggedUser) {
        return (
            <Box sx={{ mt: 10, textAlign: "center" }}>
                <Typography variant="h5">
                    אין משתמש מחובר. אנא התחבר כדי לצפות בפרטי ההזמנה.
                </Typography>
            </Box>
        );
    }
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    const handlePay = () => {
        if (cart.length === 0) {
            Swal.fire({
                title: "עגלה ריקה",
                text: "העגלה שלך ריקה!",
                icon: "warning",
                confirmButtonText: 'OK',
                confirmButtonColor: "#D81B60",
                // לפיתוח: ניווט לדף המוצרים

            });
            return;
        }


        //   const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        // } else {
        const data = {
            id: 0,
            userId: loggedUser.id,
            totalCost: total,
            date: getCurrentDate(),
            statusId: 1,
            ordersProducts: cart.map(c => ({
                id: 0,
                productId: c.productId,
                amount: c.amount,
                productOptionId: c.productOptionId ?? null, // ✅ זה מה ששומר את הוריאציה בהזמנה
            }))

        }
        setLoading(true);
        AddOrder(data)
            .then(res => {
                if (res.status === 200) {
                    Swal.fire({
                        title: "ההזמנה נרשמה במערכת \n ניצור איתכם קשר בהקדם האפשרי תודה!!",
                        text: `ע"ס ${total} ש"ח`,
                        icon: "success",
                        timer: 6000,
                        confirmButtonColor: "#58A76B",
                        customClass: { popup: "custom-swal" }
                    }).then(() => {
                        setErrors({});
                        dispatch(CLEAR_CART());
                        navigate("/");
                    });
                }
            })
            .catch(err => {
                console.error(err);
                Swal.fire({
                    title: "שגיאה בשליחת ההזמנה",
                    text: "נסי שוב בעוד רגע",
                    icon: "error",
                    confirmButtonColor: "#D81B60",
                });
            })
            .finally(() => {
                setLoading(false);
            });

    };

   const API_BASE =
    process.env.REACT_APP_API_BASE_URL || "";

    const resolveImgSrc = (img) => {
        if (!img) return null;
        if (img instanceof File) return URL.createObjectURL(img);
        const path = String(img).replace(/\\/g, "/"); // ליתר ביטחון אם הגיעו backslashes
        if (path.startsWith("http") || path.startsWith("//")) return path;
        return `${API_BASE}${path}`; // הופך "/       /..." ל־"https://localhost:7010/uploads/..."
    };


    return (
        <Card sx={{ maxWidth: 900, mx: "auto", mt: 4 }}>
            <CardContent>
                <Typography variant="h4" gutterBottom>
                    סיכום הזמנה
                </Typography>

                {/* פרטי המשתמש */}
                {/* <Box sx={{ mb: 3 }}>
                    <Typography variant="h6">פרטי לקוח</Typography>
                    <Typography>שם: {loggedUser.name}</Typography>
                    <Typography>אימייל: {loggedUser.email}</Typography>
                    <Typography>טלפון: {loggedUser.phone}</Typography>
                    <Typography>כתובת למשלוח: {loggedUser.address}</Typography>
                </Box> */}
                <UserDetailsSection />

                <Divider sx={{ my: 2 }} />

                {/* פרטי העגלה */}
                <Typography variant="h6" gutterBottom>
                    פרטי סל הקניות:
                </Typography>
                {cart.map((item) => {
                    const displayImage =
                        item.productOption?.image || item.product?.image;

                    return (
                        <Box
                            key={item.id}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",   // מרכז אנכית
                                mb: 1,
                                gap: 2,
                            }}
                        >
                            {/* צד שמאל: תמונה + שם ביחד */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                <Box
                                    component="img"
                                    src={resolveImgSrc(displayImage)}
                                    alt={item.product?.name}
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        objectFit: "cover",
                                        borderRadius: 1,
                                        border: "1px solid #eee",
                                    }}
                                />
                                <Typography sx={{ fontWeight: 600 }}>
                                    {item.product?.name}
                                    {item.productOption && (
                                        <span style={{ fontWeight: 400, color: "#555" }}>
                                            {" "}({item.productOption.value})
                                        </span>
                                    )}
                                </Typography>

                            </Box>

                            {/* צד ימין: כמות × מחיר */}
                            {(() => {
                                const basePrice = Number(item.product?.price) || 0;
                                const optionPrice = Number(item.productOption?.extraPrice) || 0;
                                const unitPrice = optionPrice > 0 ? optionPrice : basePrice;
                                const lineTotal = unitPrice * (Number(item.amount) || 0);

                                return (
                                    <Typography>
                                        כמות: {item.amount} × ₪{unitPrice.toFixed(2)} = ₪{lineTotal.toFixed(2)}
                                    </Typography>
                                );
                            })()}

                        </Box>
                    )
                }
                )}


                <Divider sx={{ my: 2 }} />

                <Typography variant="h6">
                    סה"כ לתשלום: ₪{total.toFixed(2)}
                </Typography>
            </CardContent>

            <CardActions sx={{
                gap: 2, // רווח בין הכפתורים
                pb: 2
            }}>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate("/cart")}
                >
                    חזרה לעגלה
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handlePay}
                    disabled={loading}
                >
                    {loading ? "שולח הזמנה..." : "לחץ לסיום ההזמנה"}
                </Button>
            </CardActions>
        </Card>
    );
};

export default CheckoutSummary;
